import { useContext } from "react";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import CruzIcon from "../../../../assets/images/generico/CruzIcon";
import { ContainerModalErrAutT } from "./localStyle";
import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";
import {
  resetIdTipoPuntoControl,
  wsPostTrazaPuntoControl,
} from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";

const ModalErrorAutoT = ({
  errorMsg,
  errorBack,
  errorCaution,
  dissmiss,
  errorActionButton,
}) => {
  const { pasoDispatch, puntoControlState, puntoControlDispatch } =
    useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { authState, configState } = useContext(GlobalContext);

  const pacienteCodigo = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : authState?.auth?.data?.paciente?.codigo;

  const onClickError = () => {
    if (puntoControlState.puntoControl.idTipo !== null) {
      const fecha = new Date().toISOString();
      wsPostTrazaPuntoControl({
        idtipo: puntoControlState.puntoControl.idTipo,
        fechaalta: fecha,
        idpaciente: Number(pacienteCodigo),
        idsectoralta: Number(configState?.config?.data?.sectorTurno),
        idterminal: -1,
        idturno: -1,
        idprotocolo: -1,
      })(() => {
        resetIdTipoPuntoControl()(puntoControlDispatch);
      });
    }
    if (dissmiss) {
      dissmiss();
    } else {
      setPaso(errorBack)(pasoDispatch);
    }
  };
  return (
    <ContainerModalErrAutT atention={errorCaution}>
      {errorCaution ? (
        <AlertIcon color={"white"} height={"50"} width={"50"} />
      ) : (
        <div className="cruz-circle">
          <CruzIcon color={"white"} height={"20"} width={"20"} />
        </div>
      )}
      <div className="backgorund-containerModalAutoT"></div>
      <p
        dangerouslySetInnerHTML={{
          __html: errorMsg,
        }}
      />
      {errorActionButton?.text && typeof errorActionButton?.onClick === "function" && (
        <button
          className="action-secondary"
          onClick={() => {
            try {
              errorActionButton.onClick();
            } catch (e) {
              console.error("[ModalErrorAutoT] errorActionButton.onClick falló:", e);
            }
          }}
        >
          {errorActionButton.text}
        </button>
      )}
      <button onClick={onClickError}>Aceptar</button>
    </ContainerModalErrAutT>
  );
};

export default ModalErrorAutoT;
